import { IGetaxReturnStatsResponse } from 'app/services/projects';
import PieChartStats from './PieChartStats';

const COLORS = [
  '#bfbfbf',
  '#f3722c',
  '#f8961e',
  '#90be6d',
  '#DF9999',
  '#DC3545',
];

interface ITaxReturnStatusStats {
  data: IGetaxReturnStatsResponse;
}

const InAppTaxReturnStatusStats = ({ data }: ITaxReturnStatusStats) => {
  const assignedCount = data.in_app_statuses_count.find(
    ({ status }) => status === 'assigned',
  )?.count;

  const _data = data.in_app_statuses_count
    .filter(({ status }) => status !== 'assigned' && status !== 'submitted')
    .map(({ status, count }) => {
      let name: string = status;
      let value = count;

      if (status === 'approved') {
        name = 'Paid';
        value += assignedCount || 0;
      }

      if (status === 'pending_payment') {
        name = 'Unpaid';
      }

      if (status === 'pending_pricing') {
        name = 'Price Pending';
      }

      return {
        name,
        value,
      };
    });

  return (
    <PieChartStats
      data={_data}
      total={data.tax_returns_stats.total_tax_returns_count}
      colors={COLORS}
    />
  );
};

export default InAppTaxReturnStatusStats;
